var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StandardSearchPageView',{ref:"table",attrs:{"col":3,"columns":_vm.getColumns(),"queryParams":_vm.queryParams,"searchOptions":_vm.searchOptions,"requestPromise":_vm.loadDataList}})}
var staticRenderFns = []

export { render, staticRenderFns }